module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/step4-pict01-full-f522d2d106cf4fdd48a5aa40d1ff0797.jpg";